/**
 * public/assets/js/public.js
 *
 * Console Branding Banner
 * -----------------------
 * Lightweight snippet that prints a branded message to the browser console.
 * Safe to include on any page; it has no side-effects beyond the log output.
 *
 * Example output:
 *   "Copyright © 2025 HubWare. Developed by Cahillbrand Ltd. Powered by US Launch Pad Ltd. All rights reserved."
 *
 * @package   App\Assets\JS
 * @license   Proprietary — All rights reserved.
 */

/* eslint-disable no-console */
console.log(
  `Copyright © ${new Date().getFullYear()} HubWare.`,
  'Developed by Cahillbrand Ltd.',
  'Powered by US Launch Pad Ltd.',
  'All rights reserved.'
)
/* eslint-enable no-console */
